import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, fetchColorSwatches, getSrcset, nostoATC } from "../helpers"
import { useEffect, useState } from "preact/hooks";
import Carousel from "./Carousel";
import {productCarouselOptions, productSizeCarouselOptions} from "../config"

export default function Product({ product, productZindex, index }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    // console.log("product", product);
    const handle = product?.url?.split("/")?.pop();
    const [ carouselImgs, setCarouselImgs ] = useState([]);
    const [swatches, setSwatches] = useState([]);

    // transform in useMemo 
    const isOnDiscount = product?.listPrice > product?.price;
    const discountAmount = product.listPrice && product.listPrice > product.price ? Math.round((product.listPrice - product.price) / product?.listPrice * 100) : null;

    const swatchesStringIds = product?.customFields?.find(field => field.key === "custom-sibling")?.value;
    const swatchesIds = swatchesStringIds ? JSON.parse(swatchesStringIds).map(idString => idString?.split("/")?.pop()) : [product?.productId];
    
    // console.log("swatchesIds", swatchesIds);

    useEffect(()=>{
        if (swatchesIds && swatchesIds.length > 0) {
            fetchColorSwatches(swatchesIds).then(swatches => {
                // console.log(swatches);
                setSwatches(swatches);
            });
        } 
    }, [])

    useEffect(() => {
        setCarouselImgs((product?.alternateImageUrls && product?.alternateImageUrls?.length > 0)
            ? [ product?.imageUrl, ...product?.alternateImageUrls ]
            : [ product?.imageUrl ]
        );
    }, []);

    console.log("swatches", swatches);

    return (
        <SerpElement
            as="div"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            // ns-col-12 ns-col-xs-6 ns-col-l-4 ns-p-2 ns-my-2 ns-mx-0
            class="ns-product ns-markets ns-border-box ns-clickable ns-text-undecorated ns-color-inherit product-item animation animation--item animation--item-initial animation--item-revealed"
            style={`--z-index-item: ${productZindex}; --delay-offset-multiplier: ${index};`}
            data-handle={handle}
        >
            <div class="product-item__inner">
                <div class="product-item__media product-item__media--multiple-images">
                    <a class="product-item__image-link ns-link" href={product?.url}
                    //  wk-skip="" wk-id="GUffxOcPyf61xmRfRhP-R" 
                     aria-label={product?.name}>
                    <Carousel 
                        options={productCarouselOptions}
                        // lg:hidden
                        carouselClass="product-images ns-d-flex"
                        wrapperUniqueClass={`images-${product.productId}`} 
                        init={carouselImgs.length > 1}
                    >
                        <div class="image product-item__image product-item__image--one animation--lazy-load loaded swiper-slide" style="">
                        <img alt="" class="image__img" loading="lazy" width="2400" height="3600" src={`${product?.imageUrl}&width=320`} srcSet={getSrcset(product?.imageUrl)} sizes="(max-width: 720px) calc((90vw - 12px) / 2), (max-width: 1400px) calc((93.4vw - (12px * 3)) / 4), 304px" />
                        {/* onload="javascript: this.closest('.image').classList.add('loaded')" */}
                        </div>
                        
                        {product?.alternateImageUrls?.length > 0 &&  <div class="image product-item__image loaded swiper-slide" style="">
                            <img alt="" class="image__img" loading="lazy" width="2400" height="3600" src={`${product?.alternateImageUrls[0]}&width=320`} srcSet={getSrcset(product?.alternateImageUrls[0])} sizes="(max-width: 720px) calc((90vw - 12px) / 2), (max-width: 1400px) calc((93.4vw - (12px * 3)) / 4), 304px" />
                        </div>
                        }
                        {carouselImgs.length > 2 && carouselImgs.slice(2).map((img, i) => {
                            return (
                                <div class="image product-item__image loaded swiper-slide" style="">
                                    <img alt="" class="image__img" loading="lazy" width="2400" height="3600" src={`${img}&width=320`} srcSet={getSrcset(img)} sizes="(max-width: 720px) calc((90vw - 12px) / 2), (max-width: 1400px) calc((93.4vw - (12px * 3)) / 4), 304px" />
                                </div>
                            )
                        })}
                    </Carousel>
                    </a>

                    <div class="
                        product-badges
                        product-badges--position-top
                        product-badges--position-left
                        ">
                        {discountAmount && <div class="product-badge product-badge--sale">
                            SAVE {discountAmount}%
                        </div>}
                    </div>
                    <div class="product-item__hover-action-wrap ns-sizes-container">
                        {/* <button class="btn btn--tertiary btn--x-small show-product-quickview" tabindex="0" href={product?.url}>
                        Quick View
                        </button> */}
                        {product?.skus?.map((sku, i) => {
                            const isSkuOOS = sku.availability !== "InStock";
                            const size = sku.attributes?.find(attr => attr.key === "Size")?.value || sku.name;
                            return (
                                <button class={`ns-size ${isSkuOOS ? "ns-size-oos" : ""}`} sku-id={sku?.id} pid={product?.productId} onClick={nostoATC}>
                                    {size}
                                </button>
                            )
                        })}
                    </div>
                    <button class="product-item__hoverless-quick-view-button btn btn--rounded show-product-quickview" tabindex="0" href={product?.url} title="Quick View">
                        <span class="icon icon-new icon-quick-buy ">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path class="quick-buy-circle" d="M12 22.884c6.011 0 10.884-4.873 10.884-10.884C22.884 5.99 18.01 1.116 12 1.116 5.99 1.116 1.116 5.99 1.116 12c0 6.01 4.873 10.884 10.884 10.884z" stroke="currentColor" stroke-width=".9" stroke-miterlimit="10" stroke-linecap="round"></path>
                            <path d="M14.768 11.821c-.05-.937-.082-2.315-.194-3.351-.18-1.66-.967-2.791-2.518-2.791-1.551 0-2.34 1.13-2.518 2.79-.113 1.037-.144 2.416-.194 3.352" stroke="currentColor" stroke-width=".9" stroke-miterlimit="10"></path>
                            <path d="M17.58 9.717H6.531v7.6H17.58v-7.6z" stroke="currentColor" stroke-width=".9" stroke-miterlimit="10"></path>
                        </svg>
                        </span>
                    </button>
                </div>
                <div class="product-item__meta">
                    <div class="product-item__text ta-c ">
                        <h4 class="ff-body product-item__product-title fs-product-card-title">
                            <a href={product?.url} class="ns-link">{product?.name}</a>
                        </h4>
                        <p class="product-item__price">
                            {isOnDiscount ? (
                                <>
                                    <span class="visually-hidden">Regular price</span>
                                    <s class="t-subdued ns-list-price">{format(product?.listPrice)}</s>
                                    <span class="sale ns-price" data-price="">{format(product?.price)}</span>
                                </>
                            ):(
                                <span class="product-item__price ns-price">{format(product?.price)}</span>
                            )}
                            <span class="displayed-discount fs-body-50">
                                {discountAmount && `${discountAmount}% off`}
                            </span>
                        </p>
                        <dl data-unit-price-container="" class="unit-price">
                        <dt>
                            <span class="visually-hidden visually-hidden--inline">Unit price</span>
                        </dt>
                        <dd class="unit-price__price"><span data-unit-price=""></span><span aria-hidden="true">/</span><span class="visually-hidden">per&nbsp;</span><span data-unit-base=""><span data-unit-price-base-unit=""></span></span>
                        </dd>
                        </dl>
                        <p></p>
                    </div>
                </div>
                <div class="ns-prod-swatch-container">
                    {swatches.length > 0 && swatches.map((swatch, i)=>{
                        const swatchImage = swatch.attributes?.find(attr => attr.key === "custom-image_swatch")?.value;
                        const isSwatchOOS = swatch.availability !== "InStock";
                        return (
                            <a href={swatch?.url} style={`background-image: url(${swatchImage})`} class={`ns-prod-swatch ${isSwatchOOS ? "ns-prod-swatch-oos" : ""}`}></a>
                        )
                    })}
                </div>
                <div class="product-item__hover-container"></div>
            </div>
        </SerpElement>
    )
}

{/* <img
                class="ns-w-100 ns-h-auto"
                src={product.imageUrl ?? productImagePlaceholder}
                alt={product.name}
                width="600"
                height="400"
            />
            <div class="ns-relative ns-mt-2" data-nosto-element="product">
                {tags.length > 0 && (
                    <div class="ns-tags ns-absolute ns-mb-1">
                        {tags.map(v => (
                            <span key={v.label} class={v.class}>{v.label}</span>
                        ))}
                    </div>
                )}
                {product.brand && <div class="ns-color-black ns-mb-1 ns-font-4">{product.brand}</div>}
                <div class="ns-clipped ns-text-four-lines ns-text-md-three-lines ns-mb-2 ns-font-4">{product.name}</div>
                <div aria-label="Price">
                    <span>{format(product.price)}</span>
                    {product.listPrice && product.listPrice > product.price && (
                        <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                            {format(product.listPrice)}
                        </span>
                    )}
                </div>
            </div> */}